import { IoIosArrowBack } from "react-icons/io";
import Button from "../Button";
import { useRouter } from "@tanstack/react-router";

const BackButton = () => {
  const router = useRouter();
  const goToPreviousPage = () => {
    router.history.back();
  };
  return (
    <Button onClick={goToPreviousPage} variant="neutral" className=" px-2">
      <span className="flex items-center gap-1">
        <IoIosArrowBack /> Go Back
      </span>
    </Button>
  );
};

export default BackButton;
